<template>
  <div>
    <p class="text-h6">開始前の注意事項</p>
    <v-alert
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
    >
      <a v-if="!isLight" class="start-link" @click="openPDF('operation_process')">
        操作手順
      </a>
      <a v-if="!isLight" class="start-link" @click="openPDF('course_detail')">
        コース説明
      </a>
      <a v-if="!isLight" class="start-link" @click="openPDF('about_point')">
        健チャレのポイントについて
      </a>
      <!-- モバイルアプリでは非表示 -->
      <a v-if="!isLight && !this.isMobileApp" class="start-link" @click="openPDF('easier_login')">
        簡単にログインするための設定手順
      </a>
      <a v-if="!isLight" @click="openPDF('for_smartphone_app')" class="start-link">
        健康チャレンジ専用スマートフォンアプリの使い方
      </a>
      <a v-if="!isLight" class="start-link" @click="openPDF('auto_record')">
        体重・血圧もアプリで連携可能に
      </a>
      <a v-if="!isLight && !this.isMobileApp" class="start-link" @click="openPDF('course_pack')">
        おすすめパックについて
      </a>
    </v-alert>

    <v-alert
      v-if="supportdesk"
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
    >
      <p>サポートデスク</p>
      <p style="white-space:pre-wrap;" v-text="supportdesk"></p>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'start',
  data () {
    return {
      supportdesk: '',
      isMobileApp: false
    }
  },
  computed: {
    // 運用テストかどうか（健チャレLight版）
    isLight () {
      return process.env.VUE_APP_IS_LIGHT
    }
  },
  mounted () {
    this.getSupportdeskJson()
    this.isMobileApp = this.$store.getters.getIsMobileApp
  },
  methods: {
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    },
    // cloudfront→S3からjsonファイルのサポートデスク情報を取得(手動でS3にファイルを格納する)
    getSupportdeskJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/supportdesk.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const supportdeskObj = this.response
            me.supportdesk = supportdeskObj.description
          }
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.start-link {
  display: block;
  padding: 6px 0;
}
</style>
